import React, { useState, useEffect } from 'react';
import {
    Form,
    Col,
    Row,
    Card,
} from 'antd';

import DraggerBox from 'components/DraggerBoxTable/DraggerBox';
import * as actions from 'store/actions/AuthActions';


const AssetFileForm = () => {
    const [assetFileCategoryId, setAssetFileCategoryId] = useState(null);

    useEffect(() => {
        const fetchCategory = async () => {
            const categoryId = await actions.getDocumentCategoryByCode('ASSETFILE');
            setAssetFileCategoryId(categoryId);
        };
        fetchCategory();
    }, []);

    return (
        <>
            <Form
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 18 }}
            >
                <Row
                    style={{ margin: "15px" }}
                >
                    <Col span={24} style={{}}>
                        <div className="site-card-border-less-wrapper">
                            <Card title="Details" bordered={false} style={{}}>
                                <DraggerBox mode="assetfiles" categoryId={assetFileCategoryId} />
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Form>
        </>
    );
};
export default AssetFileForm;